<template lang="pug">
#custom-page
  WtTile(ancestor)
    WtTile(parent)
      WtTile.content-container(child)
        WtDisplayRichTextHTML.html-custom-content(:html="_.get(coreProgramMeta, 'customPageContent', null)")

</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import { mapGetters } from "vuex";

export default {
  name: "CustomPage",

  components: { WtTitle, WtTile, WtDisplayRichTextHTML },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"])
  }
};
</script>

<style lang="sass">
#custom-page
  padding-top: 1rem
  .content-container
    min-height: calc(100vh - 160px)
</style>
